import React from 'react';
import { graphql } from 'gatsby';
import { ProductGrid } from '../styles/Grids';
import ProductItem from '../components/ProductItem';
import SEO from '../components/SEO';
import CategoriesFilter from '../components/CategoriesFilter';

export default function Products({ data }) {
    const products = data.products.nodes;
    return (
        <>
            {/* eslint-disable-next-line */}
            <SEO title="Products" />
            <div className="heading">
                <h2>Products</h2>
                <div className="underline"></div>
            </div>
            <CategoriesFilter />
            <ProductGrid>
                {
                    products.map((product) => (
                        <ProductItem key={product.id} product={product} />
                    ))
                }
            </ProductGrid>
        </>
    )
}

export const query = graphql`
    query productsQuery($categoryRegex: String) {
        products: allSanityProduct(filter: {
            category: {
                elemMatch: {
                    name: {
                        regex: $categoryRegex
                    }
                }
            }
        }) {
            nodes {
            id
            _type
            name
            price
            slug {
                current
            }
            variants {
                sizes
            }
            description
            images {
                asset {
                    gatsbyImageData(
                        placeholder: BLURRED
                    )
                    url
                    _id
                }
            }
        }
      }
    }
`;